module.exports = __webpack_public_path__ + "static/media/pop.1f943043.jpg";